<script>
export default {
  name: "OrgFinancesContainerIncomesPayExportInvoiceButton",
  template: `
    <gray-button
      v-if="paid"
      @click.prevent="payExportInvoice()"
      icon="fa-solid fa-ban"
      label="Marcar no pagada"
    />
    <success-button
      v-else
      @click.prevent="payExportInvoice()"
      icon="fa-solid fa-check-double"
      label="Marcar pagada"
    />
  `,
  props: {
    paid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    payExportInvoice: function () {
      this.$emit("payExportInvoice");
    }
  }
};
</script>
